import {Confirm} from '@ab/components';
import {palette} from '../../palette';
import React from 'react';

const confirmStyle = {
    width: palette.gutter * 50 + 'px',
    button: {
        paddingRight: palette.gutter * 2,
        paddingLeft: palette.gutter * 2,
        width: '100%',
    },
};

export default props => {
    return (
        <Confirm {...props} style={{...confirmStyle, ...props.style}}>
            {props.children}
        </Confirm>
    );
};
